









import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'show-info-item',
    props: {
        name: {
            type: String,
            default: '',
        },
        value: {
            default: '',
        },
        isRequired: {
            type: Boolean,
            default: false,
        },
    },
    setup() {},
});
